import {useMemo} from "react";
import {useCurrentRefinements, useInstantSearch} from "react-instantsearch";
import {useConfigContext} from "@/ConfigProvider";
import {useInstantSearchUIContext} from "@/instantsearch/InstantSearchUIProvider";
import {Badge} from "@/instantsearch/components/Badge";

export function FilterBoxToggle() {
    const {isActive, closePanel, openPanel} = useInstantSearchUIContext();
    const {items} = useCurrentRefinements();
    const {tc, algoliaRefinements: {refinementList}} = useConfigContext();
    const {results} = useInstantSearch();

    const activeFilters = useMemo(() => {
        return items.reduce((total, item) => total + item.refinements.length, 0);
    }, [items]);

    const hasAvailableFilters = useMemo(() => {
        if (!results) return false;
        return refinementList.some((item) => {
            if (item.display_type === 3) {
                const stats = results.getFacetStats(item.name);
                return !!stats && stats.min !== stats.max;
            }
            const values = results.getFacetValues(item.name, {});
            return Array.isArray(values) && values.length > 0;
        });
    }, [refinementList, results]);

    const openFilter = () => {
        if (isActive) {
            closePanel();
        } else {
            openPanel();
        }
    }

    if (!hasAvailableFilters) {
        return null;
    }

    return (
        <button className={"ais-filterBoxToggle button button--action"}
                id={"filterToggle"}
                aria-controls={"filterSidebar"}
                aria-expanded={isActive}
                onClick={() => {
                    openFilter()
                }}
        >
            <i className={"icon icon-filter"} aria-hidden={true} />
            <span className="d-md-none">{tc.algoliaFilter}</span>
            <Badge value={activeFilters}/>
        </button>
    );
}
